import React from "react";
import propTypes from "prop-types";
import { Icon } from 'in-touch-icons';
import closeAllNav from '../../../../helpers/closeAllNav';

class AccordionItem extends React.Component {
	constructor(props) {
		super(props);
		this.accordionref = React.createRef();
	}
	
	componentDidMount() {
		this.accordion = this.accordionref.current;
		this.height = this.accordionref.current.clientHeight;
		this.accordionref.current.classList.add('js-closed');
	}

	addRemoveHeight = (title, isOpen, e) => {

		const thisButton = e.currentTarget,
			navButtons =  document.getElementsByClassName('navigation__heading-text');

			if (!this.props.isOpen) {
				for ( let i = 0; i < navButtons.length; i++ ){
					navButtons[i].classList.remove('js-open');
				}
				thisButton.classList.add('js-open');
				this.accordion.style.height = `${this.height}px`;
				
			} else {
				thisButton.classList.remove('js-open');
				this.accordion.style.height = `0px`;
			}
		this.props.handleClick(title, isOpen);
	}	
	
	render() {
		const { title, svgClass, contentClass } = this.props;
		
		const { btnClass, icon, iconName, iconWidth, iconFill, iconAriaHidden, iconFocussable } = this.props.childProps;

		!this.props.allowMultipleOpen && !this.props.isOpen && this.accordionref.current !== null && this.accordionref.current.removeAttribute('style');

		return (
			<li>
				<button className={btnClass} onClick={(e) => this.addRemoveHeight(this.props.title, !this.props.isOpen, e)}>
					{icon && <Icon iconName={iconName} fill={iconFill} width={iconWidth} ariaHidden={iconAriaHidden} focussable={iconFocussable} svgClass={svgClass} />}
					{title}
				</button>
				<ul ref={this.accordionref} className={`${contentClass} navigation-list accordion-content`} onClick={() => closeAllNav('(max-width: 766px)')}>{this.props.children}</ul>
			</li>
		);
	}
}

AccordionItem.propTypes = {
	children: propTypes.instanceOf(Object).isRequired,
	isOpen: propTypes.bool,
	title: propTypes.string,
	onClick: propTypes.func,
	btnClass: propTypes.string.isRequired,
	contentClass: propTypes.string.isRequired
};

AccordionItem.defaultProps = {
	contentClass: '',
	btnClass: '',
}

export default AccordionItem;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/accordion/AccordionItem.js